export const OrderShippingStatuses = {
    NEW: 1,
    DISPATCH_DATE_ADDED: 2,
    DETAILS_ADDED: 3,
    CONFIRM: 4,
}